import { KernCAConfig } from "../../Redux/roStore";
import {
  Loading_Box_PalletId_Barcode_Scan_Api,
  Loading_Box_PalletId_Delete_Api,
  Loading_Box_PalletId_Grid_Api,
  Loading_Box_PalletId_Save_Api,
} from "../../Server/ApiV2";

export const WMS_PICKING_DROP_ID_Flag = () => {
  const { DBKernObj } = KernCAConfig();
  if (DBKernObj?.WMS_PICKING_DROP_ID_LOADING?.Val === "Y") return true;
  else return false;
};

export const Loading_Box_PalletId_Grid = async (data) => {
  try {
    const response = await Loading_Box_PalletId_Grid_Api(data);
    return response;
  } catch (err) {
    console.error("An error occurred:", err);
    return null;
  }
};

export const Loading_Box_PalletId_Save = async (data) => {
  try {
    const response = await Loading_Box_PalletId_Save_Api(data);
    return response;
  } catch (err) {
    console.error("An error occurred:", err);
    return null;
  }
};

export const Loading_Box_PalletId_Delete = async (data) => {
  try {
    const response = await Loading_Box_PalletId_Delete_Api(data);
    return response;
  } catch (err) {
    console.error("An error occurred:", err);
    return null;
  }
};

export const Loading_Box_PalletId_Barcode_Scanning = async (data) => {
  try {
    const response = await Loading_Box_PalletId_Barcode_Scan_Api(data);
    return response;
  } catch (err) {
    console.error("An error occurred:", err);
    return null;
  }
};
